import * as types from '../constants/tradepanelConstants';
import moment from 'moment';

const initialState = {
  bmList:[],
  tradeLayout:[],
  alertWindow:{
    label:"",
    MSG:"",
    flag:false,
    TS:null,
  },
  trdingFlag:null,
  popoutLimit:0,
  payReqFlag:true,
  bmDate:moment(),
  bmFlag:false,
  updateBm:0,
  loading: false,
  tradePlaced: false,
  error: null,
  responseData: null
};

const getInitialBMData = (BMList) => {
  return BMList.map((item,index) => {
    return {
      ...item,
      BM:item.bm_code,
      BMD:item.mb_desc,
      PRM:item.prm_comm,
      IID:item.inst_desc,
    };
  });
};
const cutofbenchmrklist = (msg,bmlist) =>{
  const item =Object.assign([],bmlist);
  for(let i=0;i<item.length;i++){
    if(msg.BMC===item[i].BMC){
      item.splice(i, 1);
    }
  }
  localStorage.setItem('bmList', JSON.stringify(item));
  return item;
}
const updatebenchmrklist = (msg,bmlist) =>{
    const item =Object.assign([],bmlist);
  if(msg.P==="A"){
    var obj={
      BMC:msg.BM,
      BMN:msg.BMD,
      BPS:msg.PRM,
      BEMT:msg.BEMT,
      IID:msg.IID
    }
    item.push(obj);
  }else if(msg.P==="E"){
    var obj={
      BMC:msg.BM,
      BMN:msg.BMD,
      BPS:msg.PRM,
      BEMT:msg.BEMT,
      IID:msg.IID
    }
    for(let i=0;i<item.length;i++){
      if(msg.BM===item[i].BMC){
        item[i]=obj;
      }
    }
  } else if(msg.P==="D"){
    for(let i=0;i<item.length;i++){
      if(msg.BM===item[i].BMC){
        item.splice(i, 1);
      }
    }
  }
  localStorage.setItem('bmList', JSON.stringify(item));
  return item;
}
const createAlert = (message) =>{
  return {
    label:"Message from Dealer",
    MSG:message.MSG,
    flag:true,
    TS:message.TS
  };
}
const closeAlert = (alert) =>{
  alert.flag=false;
  return alert;
}
export default function(state = initialState, action)  {
  switch (action.type) {
    case types.ORDER_SUCCESS:
      return {
        ...state,
        showPopup: true
      };
    case types.UPDATE_TRADE_SOCKET_DATA:
      return {
        ...state,
      };
    case types.LOAD_TRADE_SOCKET_DATA:
      return {
        ...state,
      };
    case types.CLOSE_SOCKET_TRADE:
      return {
        ...state,
      };
    case types.CLOSE_WEBSOCKET_TRADE:
    return{
      ...state,
    };
    case types.HIDE_MODAL:
      return {
        ...state,
        showPopup: false,
        executeSuccess: false,
      };
    case types.EXECUTE_SUCCESS:
      return {
        ...state,
        executeSuccess: true,
        executeData: action.data
      };
      case types.GETBM:
      localStorage.setItem('bmFlag',false);
      return{
        ...state,
        bmFlag:false
      };
      case types.GETBM_SUCCESS:
      localStorage.setItem('bmList', JSON.stringify(action.result.data));
      localStorage.setItem('bmDate',action.initialState.valDate);
      localStorage.setItem('bmFlag',true);
      return{
        ...state,
        bmList:action.result.data,
        bmDate:action.initialState.valDate,
        bmFlag:true
      //  bmList:getInitialBMData(action.result.data.BM)
      };
      case types.GETBM_FAILURE:localStorage.setItem('bmFlag',false);
      return{
        ...state,
        bmFlag:false
      };
      case types.SHOW_ALERT:
      //console.log("SHOW_ALERT alertWindow");
      return{
        ...state,
      alertWindow:createAlert(action.msg),
    };
    case types.HIDE_ALERT:
  //  console.log("HIDE_ALERT alertWindow "+JSON.stringify(state.alertWindow));
    return{
      ...state,
    alertWindow:false,
  };
  case types.TRD_STATUS:
    localStorage.setItem('trdingFlag', action.status);
  return{
    ...state,
    trdingFlag:action.status,
  }
  case types.CUTOFF_BENCHMARK:
  return{
    ...state,
    bmList:cutofbenchmrklist(action.message,state.bmList),
  };
  case types.UPDATE_BM_LIST:
  var randomNo=Math.floor((Math.random() * 1000000) + 1);
  return{
    ...state,
    bmList:updatebenchmrklist(action.message,state.bmList),
    updateBm:randomNo
  };
  case types.UPDATE_POPOUT_COUNT://console.log(" UPDATE_POPOUT_COUNT "+action.popoutLimit);
  return{
    ...state,
    popoutLimit:action.popoutLimit,
  };
  case types.CANCEL_PAYMENT_REQUEST:
  return{
    ...state,
    payReqFlag:action.paymentReq
  };
  case types.MODIFY_PAYMENT_REQUEST:
  return{
    ...state,
    payReqFlag:action.paymentReq
  };
  case types.ADD_PAYMENT_REQUEST:
  return{
    ...state,
    payReqFlag:action.paymentReq
  };
  case types.PAYMENT_FAILED_FLAG:
  return{
    ...state,
    payReqFlag:action.flag
  };
  case types.PLACE_FWD_TRADE:
    localStorage.setItem("tradePlaced","false");
    localStorage.setItem("loading","true");
      return {
        ...state,
        loading: true,
        tradePlaced: false,
        error: null,
        responseData: null
      };
  case types.PLACE_FWD_TRADE_SUCCESS:
    localStorage.setItem("tradePlaced","true");
    localStorage.setItem("loading","false");
      return {
        ...state,
        loading: false,
        tradePlaced: true,
        error: null,
        responseData: action.result
      };
  case types.PLACE_FWD_TRADE_FAILURE:
    localStorage.setItem("tradePlaced","false");
    localStorage.setItem("loading","false");
      return {
        ...state,
        loading: false,
        tradePlaced: false,
        error: action.result,
        responseData: null
      };
  
  default:
      return state;
  }
}
